import { Component, EventEmitter, HostListener, Input, OnDestroy, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { IdleDistributedService } from '@tekman/onmat/service/onmat';
import { ModalFactoryService } from '@tekman/shared/service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'idle-alert',
  templateUrl: './idle-alert.component.html',
  styleUrls: ['./idle-alert.component.scss'],
})
export class IdleAlertComponent implements OnInit, OnDestroy {
  @ViewChild('idleModalTemplate') idleModalTemplate: TemplateRef<any>;

  @Input() idleFrame: number;
  @Input() countDownFrame: number;

  @Output() logoutEvent: EventEmitter<any> = new EventEmitter<any>();
  @Output() checkSessionEvent: EventEmitter<any> = new EventEmitter<any>();

  subscription: Subscription;
  countDown: number;
  countDownListener: any;

  constructor(public idleService: IdleDistributedService, private modalFactoryService: ModalFactoryService) {}

  ngOnInit(): void {
    this.idleService.init(this.idleFrame);
    this.subscription = this.idleService.idle$.subscribe(isIdle => {
      if (isIdle) {
        this.initCountDown();
      } else {
        clearInterval(this.countDownListener);
        this.closeModal();
      }
    });
    this.modalFactoryService.overlayClicked$.subscribe(() => {
      this.continue();
    });
  }

  @HostListener('window:mousedown')
  @HostListener('window:wheel')
  @HostListener('window:touchstart')
  @HostListener('window:keydown')
  pushTimeout() {
    this.idleService.moveTimeout();
  }

  @HostListener('document:visibilitychange', ['$event.target.visibilityState'])
  focusTab(state) {
    if (state === 'visible') {
      this.checkSessionEvent.emit();
    }
  }

  initCountDown() {
    this.modalFactoryService.open(
      {
        template: this.idleModalTemplate,
      },
      { width: 780, disableClose: false }
    );
    this.countDown = this.countDownFrame * 1000;
    this.countDownListener = setInterval(() => {
      this.countDown = this.countDown - 1000;
      if (this.countDown <= 0) {
        this.logout();
      }
    }, 1000);
  }

  logout() {
    clearInterval(this.countDownListener);
    this.logoutEvent.emit();
  }

  closeModal() {
    this.modalFactoryService.close();
  }

  continue() {
    clearInterval(this.countDownListener);
    this.idleService.restart();
    this.closeModal();
  }

  ngOnDestroy(): void {
    clearInterval(this.countDownListener);
    this.subscription.unsubscribe();
  }
}
